export const getScores = (maxScore: number, minScore: number, score?: number) => {
  const scores = [];
  for (let i = minScore; i <= maxScore; i++) {
    const selected = score === i;
    scores.push({
      value: i,
      selected,
      score: i,
    });
  }
  return scores;
};
